var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KvEditor',{attrs:{"value":_vm.editorValue,"placeholder":_vm.placeholder,"height":_vm.height,"variant":_vm.variant,"size":_vm.size,"disabled":_vm.disabled,"has-error":_vm.hasError},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }